import React, { useState, Fragment, useEffect } from 'react';
import _ from 'lodash';
import { TextField, IconButton } from 'material-ui';
import ContentAddIcon from 'material-ui/svg-icons/content/add';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove';
import MapComponent from '../Merging/Map';

function getDefaultCoords() {
    return {
        lat: 0,
        lng: 0,
    };
}

function mapCoordsToArray(coords) {
    return coords.map(coord => {
        return [coord.lng, coord.lat];
    });
}

function ByCoordsPage({area, onChangeArea}) {
    const [coords, setCoords] = useState([]);
    const [editCoordsMarker, setEditCoordsMarker] = useState(null);

    useEffect(() => {
        if (area) {
            if (area.areaCoordinates && area.areaCoordinates.length) {
                const selectedAreaCoords = area.areaCoordinates.map(item => {
                    return {
                        lat: item[1],
                        lng: item[0],
                    }
                });
                setCoords(selectedAreaCoords);
            } else if (area.isNew || !area.areaCoordinatesPolygons || !area.areaCoordinatesPolygons.coordinates || !area.areaCoordinatesPolygons.coordinates.length) {
                setCoords([getDefaultCoords()]);
            }
        } else {
            setCoords([]);
        }
    }, [area]);

    useEffect(() => {
        if (
            coords[0] && coords[coords.length-1] &&
            (
                (coords[0].lat !== coords[coords.length-1].lat) ||
                (coords[0].lng !== coords[coords.length-1].lng)
            )
        ) {
            const newCoords = _.cloneDeep(coords);
            newCoords[coords.length] = newCoords[0];
            setCoords(newCoords);
        }
    }, [coords]);

    const changeCoords = (changes) => {
        const newCoords = _.cloneDeep(coords);

        changes.forEach(({index, type, value}) => {
            newCoords[index][type] = parseFloat(value);
        });

        setCoords(newCoords);
        const mappedCoords = mapCoordsToArray(newCoords);
        onChangeArea({
            ...area,
            areaCoordinates: mappedCoords,
            areaCoordinatesPolygons: {
                type: 'MultiPolygon',
                coordinates:[
                    [mappedCoords]
                ],
            }
        });
    }

    const changeCoordsList = (type, index) => {
        const newCoords = _.cloneDeep(coords);
        if (type === 'add') {
            newCoords.splice(index+1, 0, getDefaultCoords());
            setCoords(newCoords);
        }

        if (type === 'rm') {
            if (coords.length === 1) {
                setCoords([getDefaultCoords()]);
            } else {
                newCoords.splice(index, 1);
                setCoords(newCoords);
            }
        }

        const mappedCoords = mapCoordsToArray(newCoords);
        onChangeArea({
            ...area,
            areaCoordinates: mappedCoords,
            areaCoordinatesPolygons: {
                type: 'MultiPolygon',
                coordinates:[
                    [mappedCoords]
                ],
            }
        });
    }

    const onCoordsMouseOver = index => {
        setEditCoordsMarker(index);
    }

    const onCoordsMouseOut = () => {
        setEditCoordsMarker(null);
    }

    return (
        <div className='row'>
            <div 
                className='col-xs-4'
                style={{ overflowY: 'auto', height: '74.5vh' }}    
            >
                {
                    coords.map((coord, _i) => {
                        return (
                            <CoordsPair 
                                key={`coords_${_i}`}
                                index={_i}
                                changeCoords={changeCoords}
                                changeCoordsList={changeCoordsList}
                                lat={coord.lat}
                                lng={coord.lng}
                                isLast={_i === coords.length-1}
                                onMouseOver={onCoordsMouseOver}
                                onMouseOut={onCoordsMouseOut}
                            />
                        );
                    })
                }
            </div>
            <div className='col-xs-8'>
                <MapComponent
                    coordinates={[]}
                    type="area"
                    loadingElement={<div style={{height: `100%`}}/>}
                    containerElement={<div style={{height: `450px`}}/>}
                    mapElement={<div style={{height: `100%`}}/>}
                    areaPolygon={coords}
                    editCoordsMarker={editCoordsMarker}
                />
            </div>
        </div>
    );
}

function CoordsPair({lat, lng, changeCoords, changeCoordsList, index, isLast, onMouseOver, onMouseOut}) {
    return (
        <div 
            className='row' 
            onMouseOver={() => onMouseOver(index)}
            onMouseOut={onMouseOut}
        >
            <div className='col-xs-4'>
                <TextField
                    onChange={(_e, value) => changeCoords([{index, type: 'lat', value}])}
                    value={lat || ''}
                    hintText='Lat'
                    type='number'
                    fullWidth
                    disabled={index !== 0 && isLast}
                    errorText={!lat && 'Enter latitude.'}
                    style={{ fontSize: '13px' }}
                />
            </div>
            <div className='col-xs-4'>
                <TextField 
                    onChange={(_e, value) => changeCoords([{index, type: 'lng', value}])}
                    value={lng || ''}
                    hintText='Lng'
                    type='number'
                    fullWidth
                    disabled={index !== 0 && isLast}
                    errorText={!lng && 'Enter longitude.'}
                    style={{ fontSize: '13px' }}
                />
            </div>
            {
                (index === 0 || !isLast) && 
                (<Fragment>
                    <div className='col-xs-1'>
                        <IconButton>
                            <ContentAddIcon color='green' onClick={() => changeCoordsList('add', index)} />
                        </IconButton>
                    </div>
                    <div className='col-xs-1'>
                        <IconButton>
                            <ContentRemoveIcon color='red' onClick={() => changeCoordsList('rm', index)} />
                        </IconButton>
                    </div>
                </Fragment>)
            }
            
        </div>
    );
}

export default ByCoordsPage;



// WEBPACK FOOTER //
// ./app/components/Regions/ByCoords/ByCoordsPage.jsx